import React from 'react';
import {
    CheckCircleRounded,
    ErrorRounded,
    WarningRounded,
    SyncRounded,
    SignalCellularNodataRounded,
    PowerOffRounded,
    LinkOffRounded,
} from "@mui-symbols-material/w200";
import { IOT_STATUS_COLOR_MAP, getIotStatusLabel } from "../../config/iotConnectionStatusConfig";
import { TFunction } from "i18next";

/**
 * Icon per IoT connection status. `NEVER_CONNECTED` uses the same LinkOff icon as
 * the hero's "Not connected" state; colors come from the shared status config.
 */
const STATUS_ICON: Record<string, typeof CheckCircleRounded> = {
    RUNNING: CheckCircleRounded,
    WARNING: WarningRounded,
    ERROR: ErrorRounded,
    DATA_BUFFERING: SyncRounded,
    CURRENTLY_OFFLINE: SignalCellularNodataRounded,
    NEVER_CONNECTED: LinkOffRounded,
    OFF: PowerOffRounded,
};

interface Props {
    connectionStatus: string;

}


export const connectionStatusIconFunc = ({ connectionStatus, size = 70 }: Props & { size?: number }) => {
    const Icon = connectionStatus ? STATUS_ICON[connectionStatus] : undefined;
    if (!Icon) {
        return null;
    }

    return <Icon sx={{ width: size, height: size, color: IOT_STATUS_COLOR_MAP[connectionStatus] }} />;
};


export const connectionStatusTextFunc = ({ connectionStatus, t, isSystem }: Props & { t: TFunction; isSystem?: boolean }) => {
    if (!connectionStatus) {
        return null;
    }

    return getIotStatusLabel(connectionStatus, t, { isSystem });
}


